// frontend/src/app/pages/home/tree/tree-canvas/tree-colors.ts
export const TreeColors = ['green', 'red', 'yellow', 'pink', 'cyan', 'orange', 'beige', 'darkblue', 'purple', 'brown', 'navy'] as const;

export type TreeColor = (typeof TreeColors)[number] | 'unassigned';
